"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.concatTranslation = exports.ConcatTranslation = exports.concatScaleVector2 = exports.ConcatScaleVector2 = exports.subtractAssign = exports.subtract = exports.Subtract = exports.addAssign = exports.add = exports.Add = exports.shearMatrix4 = exports.ShearMatrix4 = exports.shearTranslation = exports.ShearTranslation = exports.shear = exports.Shear = exports.shearVector2 = exports.ShearVector2 = exports.translation = exports.Translation = exports.scale = exports.Scale = exports.scaleVector2 = exports.ScaleVector2 = exports.quaternion = exports.Quaternion = exports.eulerZXY = exports.EulerZXY = exports.eulerYXZ = exports.EulerYXZ = exports.eulerXYZ = exports.EulerXYZ = exports.rotationVector3 = exports.RotationVector3 = exports.rotationZMatrix2 = exports.RotationZMatrix2 = exports.rotationZVector2 = exports.RotationZVector2 = exports.rotationZ = exports.RotationZ = exports.rotationY = exports.RotationY = exports.rotationX = exports.RotationX = exports.rotationAxis = exports.RotationAxis = exports.identity = exports.Identity = exports.determinant = exports.equals = void 0;
exports.copy = exports.Copy = exports.transpose = exports.Transpose = exports.inverse = exports.Inverse = exports.concat = exports.Concat = exports.concat2x3 = exports.Concat2x3 = exports.concatMatrix2 = exports.ConcatMatrix2 = void 0;
const vector3_1 = require("./vector3");
const isNanVal = Number.isNaN;
const absOf = Math.abs;
const sinOf = Math.sin;
const cosOf = Math.cos;
const sqrtOf = Math.sqrt;
const epsilon = 1e-10;
const vec3 = { x: 0.0, y: 0.0, z: 0.0 };
function equals(a, b, e = epsilon) {
    return absOf(b.r00 - a.r00) < e && absOf(b.r10 - a.r10) < e && absOf(b.r20 - a.r20) < e &&
        absOf(b.r01 - a.r01) < e && absOf(b.r11 - a.r11) < e && absOf(b.r21 - a.r21) < e &&
        absOf(b.r02 - a.r02) < e && absOf(b.r12 - a.r12) < e && absOf(b.r22 - a.r22) < e;
}
exports.equals = equals;
/**
 * |M|
 */
function determinant(m) {
    const { r10, r11, r12, r20, r21, r22 } = m;
    return m.r00 * (r11 * r22 - r12 * r21) + m.r01 * (r12 * r20 - r10 * r22) + m.r02 * (r10 * r21 - r11 * r20);
}
exports.determinant = determinant;
/**
 * Î
 */
function Identity() {
    return {
        r00: 1.0, r10: 0.0, r20: 0.0,
        r01: 0.0, r11: 1.0, r21: 0.0,
        r02: 0.0, r12: 0.0, r22: 1.0
    };
}
exports.Identity = Identity;
/**
 * Mᵣ = Î
 */
function identity(r) {
    r.r00 = 1.0;
    r.r10 = 0.0;
    r.r20 = 0.0;
    r.r01 = 0.0;
    r.r11 = 1.0;
    r.r02 = 0.0;
    r.r02 = 0.0;
    r.r12 = 0.0;
    r.r22 = 1.0;
    return r;
}
exports.identity = identity;
/**
 * R(v⃗, θ)
 */
function RotationAxis(v, rad) {
    return rotationAxis({
        r00: 1.0, r10: 0.0, r20: 0.0,
        r01: 0.0, r11: 1.0, r21: 0.0,
        r02: 0.0, r12: 0.0, r22: 1.0
    }, v, rad);
}
exports.RotationAxis = RotationAxis;
/**
 * Mᵣ = R(v⃗, θ)
 */
function rotationAxis(r, v, rad) {
    const { x, y, z } = v;
    const sin = sinOf(rad), cos = cosOf(rad), vers = 1.0 - cos;
    const xSin = x * sin, ySin = y * sin, zSin = z * sin;
    const xyVers = x * y * vers, xzVers = x * z * vers, yzVers = y * z * vers;
    r.r00 = cos + vers * Math.pow(x, 2);
    r.r10 = xyVers + zSin;
    r.r20 = xzVers - ySin;
    r.r01 = xyVers - zSin;
    r.r11 = cos + vers * Math.pow(y, 2);
    r.r21 = yzVers + xSin;
    r.r02 = xzVers + ySin;
    r.r12 = yzVers - xSin;
    r.r22 = cos + vers * Math.pow(z, 2);
    return r;
}
exports.rotationAxis = rotationAxis;
/**
 * R(x̂, θ)
 */
function RotationX(rad) {
    return rotationX({
        r00: 1.0, r10: 0.0, r20: 0.0,
        r01: 0.0, r11: 1.0, r21: 0.0,
        r02: 0.0, r12: 0.0, r22: 1.0
    }, rad);
}
exports.RotationX = RotationX;
/**
 * Mᵣ = R(x̂, θ)
 */
function rotationX(r, rad) {
    const sin = sinOf(rad);
    const cos = cosOf(rad);
    r.r00 = 1.0;
    r.r10 = 0.0;
    r.r20 = 0.0;
    r.r01 = 0.0;
    r.r11 = cos;
    r.r21 = sin;
    r.r02 = 0.0;
    r.r12 = -sin;
    r.r22 = cos;
    return r;
}
exports.rotationX = rotationX;
/**
 * R(ŷ, θ)
 */
function RotationY(rad) {
    return rotationY({
        r00: 1.0, r10: 0.0, r20: 0.0,
        r01: 0.0, r11: 1.0, r21: 0.0,
        r02: 0.0, r12: 0.0, r22: 1.0
    }, rad);
}
exports.RotationY = RotationY;
/**
 * Mᵣ = R(ŷ, θ)
 */
function rotationY(r, rad) {
    const sin = sinOf(rad);
    const cos = cosOf(rad);
    r.r00 = cos;
    r.r10 = 0.0;
    r.r20 = -sin;
    r.r01 = 0.0;
    r.r11 = 1.0;
    r.r21 = 0.0;
    r.r02 = sin;
    r.r12 = 0.0;
    r.r22 = cos;
    return r;
}
exports.rotationY = rotationY;
/**
 * R(ẑ, θ)
 */
function RotationZ(rad) {
    return rotationZ({
        r00: 1.0, r10: 0.0, r20: 0.0,
        r01: 0.0, r11: 1.0, r21: 0.0,
        r02: 0.0, r12: 0.0, r22: 1.0
    }, rad);
}
exports.RotationZ = RotationZ;
/**
 * Mᵣ = R(ẑ, θ)
 */
function rotationZ(r, rad) {
    const sin = sinOf(rad);
    const cos = cosOf(rad);
    r.r00 = cos;
    r.r10 = sin;
    r.r20 = 0.0;
    r.r01 = -sin;
    r.r11 = cos;
    r.r21 = 0.0;
    r.r02 = 0.0;
    r.r12 = 0.0;
    r.r22 = 1.0;
    return r;
}
exports.rotationZ = rotationZ;
/**
 * [ x⃗  x⃗⊥  ẑ ]
 */
function RotationZVector2(x) {
    return {
        r00: x.x, r10: x.y, r20: 0.0,
        r01: -x.y, r11: x.x, r21: 0.0,
        r02: 0.0, r12: 0.0, r22: 1.0
    };
}
exports.RotationZVector2 = RotationZVector2;
/**
 * Mᵣ = [ x⃗  x⃗⊥  ẑ ]
 */
function rotationZVector2(r, x) {
    r.r00 = x.x;
    r.r10 = x.y;
    r.r20 = 0.0;
    r.r01 = -x.y;
    r.r11 = x.x;
    r.r21 = 0.0;
    r.r02 = 0.0;
    r.r12 = 0.0;
    r.r22 = 1.0;
    return r;
}
exports.rotationZVector2 = rotationZVector2;
/**
 * [ m⁰ m¹ ẑ ]
 */
function RotationZMatrix2(m) {
    return {
        r00: m.r00, r10: m.r10, r20: 0.0,
        r01: m.r01, r11: m.r11, r21: 0.0,
        r02: 0.0, r12: 0.0, r22: 1.0
    };
}
exports.RotationZMatrix2 = RotationZMatrix2;
/**
 * Mᵣ = [ m⁰ m¹ ẑ ]
 */
function rotationZMatrix2(r, m) {
    r.r00 = m.r00;
    r.r10 = m.r10;
    r.r20 = 0.0;
    r.r01 = m.r01;
    r.r11 = m.r11;
    r.r21 = 0.0;
    r.r02 = 0.0;
    r.r12 = 0.0;
    r.r22 = 1.0;
    return r;
}
exports.rotationZMatrix2 = rotationZMatrix2;
/**
 * [ x⃗  y⃗  x⃗×y⃗ ]
 */
function RotationVector3(x, y) {
    return rotationVector3({
        r00: 1.0, r10: 0.0, r20: 0.0,
        r01: 0.0, r11: 1.0, r21: 0.0,
        r02: 0.0, r12: 0.0, r22: 1.0
    }, x, y);
}
exports.RotationVector3 = RotationVector3;
/**
 * Mᵣ = [ x⃗  y⃗  x⃗×y⃗ ]
 */
function rotationVector3(r, x, y) {
    const z = (0, vector3_1.cross)(vec3, x, y);
    r.r00 = x.x;
    r.r10 = x.y;
    r.r20 = x.z;
    r.r01 = y.x;
    r.r11 = y.y;
    r.r21 = y.z;
    r.r02 = z.x;
    r.r12 = z.y;
    r.r22 = z.z;
    return r;
}
exports.rotationVector3 = rotationVector3;
/**
 * R(x̂, v⃗₀)R(ŷ, v⃗₁)R(ẑ, v⃗₂)
 */
function EulerXYZ(v) {
    return eulerXYZ({
        r00: 1.0, r10: 0.0, r20: 0.0,
        r01: 0.0, r11: 1.0, r21: 0.0,
        r02: 0.0, r12: 0.0, r22: 1.0
    }, v);
}
exports.EulerXYZ = EulerXYZ;
/**
 * Mᵣ = R(x̂, v⃗₀)R(ŷ, v⃗₁)R(ẑ, v⃗₂)
 */
function eulerXYZ(r, v) {
    const { x, y, z } = v;
    const sx = sinOf(x), cx = cosOf(x);
    const sy = sinOf(y), cy = cosOf(y);
    const sz = sinOf(z), cz = cosOf(z);
    r.r00 = cy * cz;
    r.r10 = cx * sz + sx * sy * cz;
    r.r20 = sx * sz - cx * sy * cz;
    r.r01 = -cy * sz;
    r.r11 = cx * cz - sx * sy * sz;
    r.r21 = sx * cz + cx * sy * sz;
    r.r02 = sy;
    r.r12 = -sx * cy;
    r.r22 = cx * cy;
    return r;
}
exports.eulerXYZ = eulerXYZ;
/**
 * R(ŷ, v⃗₁)R(x̂, v⃗₀)R(ẑ, v⃗₂)
 */
function EulerYXZ(v) {
    return eulerYXZ({
        r00: 1.0, r10: 0.0, r20: 0.0,
        r01: 0.0, r11: 1.0, r21: 0.0,
        r02: 0.0, r12: 0.0, r22: 1.0
    }, v);
}
exports.EulerYXZ = EulerYXZ;
/**
 * Mᵣ = R(ŷ, v⃗₁)R(x̂, v⃗₀)R(ẑ, v⃗₂)
 */
function eulerYXZ(r, v) {
    const { x, y, z } = v;
    const sx = sinOf(x), cx = cosOf(x);
    const sy = sinOf(y), cy = cosOf(y);
    const sz = sinOf(z), cz = cosOf(z);
    r.r00 = cy * cz + sy * sx * sz;
    r.r10 = cx * sz;
    r.r20 = -sy * cz + cy * sx * sz;
    r.r01 = -cy * sz + sy * sx * cz;
    r.r11 = cx * cz;
    r.r21 = sy * sz + cy * sx * cz;
    r.r02 = sy * cx;
    r.r12 = -sx;
    r.r22 = cy * cx;
    return r;
}
exports.eulerYXZ = eulerYXZ;
/**
 * R(ẑ, v⃗₂)R(x̂, v⃗₀)R(ŷ, v⃗₁)
 */
function EulerZXY(v) {
    return eulerZXY({
        r00: 1.0, r10: 0.0, r20: 0.0,
        r01: 0.0, r11: 1.0, r21: 0.0,
        r02: 0.0, r12: 0.0, r22: 1.0
    }, v);
}
exports.EulerZXY = EulerZXY;
/**
 * Mᵣ = R(ẑ, v⃗₂)R(x̂, v⃗₀)R(ŷ, v⃗₁)
 */
function eulerZXY(r, v) {
    const { x, y, z } = v;
    const sx = sinOf(x), cx = cosOf(x);
    const sy = sinOf(y), cy = cosOf(y);
    const sz = sinOf(z), cz = cosOf(z);
    r.r00 = cz * cy - sz * sx * sy;
    r.r10 = sz * cy + cz * sx * sy;
    r.r20 = -cx * sy;
    r.r01 = -sz * cx;
    r.r11 = cz * cx;
    r.r21 = sx;
    r.r02 = cz * sy + sz * sx * cy;
    r.r12 = sz * sy - cz * sx * cy;
    r.r22 = cx * cy;
    return r;
}
exports.eulerZXY = eulerZXY;
/**
 * R(q̂)
 */
function Quaternion(q) {
    return quaternion({
        r00: 1.0, r10: 0.0, r20: 0.0,
        r01: 0.0, r11: 1.0, r21: 0.0,
        r02: 0.0, r12: 0.0, r22: 1.0
    }, q);
}
exports.Quaternion = Quaternion;
/**
 * Mᵣ = R(q̂)
 */
function quaternion(r, q) {
    const { x, y, z, w } = q;
    const xx = Math.pow(x, 2), yy = Math.pow(y, 2), zz = Math.pow(z, 2);
    const xy = x * y, yz = y * z, xz = x * z;
    const xw = x * w, yw = y * w, zw = z * w;
    const s = 2.0 / sqrtOf(xx + yy + zz + Math.pow(w, 2));
    r.r00 = 1.0 - s * (yy + zz);
    r.r10 = s * (xy + zw);
    r.r20 = s * (xz - yw);
    r.r01 = s * (xy - zw);
    r.r11 = 1.0 - s * (xx + zz);
    r.r21 = s * (yz + xw);
    r.r02 = s * (xz + yw);
    r.r12 = s * (yz - xw);
    r.r22 = 1.0 - s * (xx + yy);
    return r;
}
exports.quaternion = quaternion;
/**
 * [ x̂v⃗₀  ŷv⃗₁  ẑ ]
 */
function ScaleVector2(v) {
    return {
        r00: v.x, r10: 0.0, r20: 0.0,
        r01: 0.0, r11: v.y, r21: 0.0,
        r02: 0.0, r12: 0.0, r22: 1.0
    };
}
exports.ScaleVector2 = ScaleVector2;
/**
 * Mᵣ = [ x̂v⃗₀  ŷv⃗₁  ẑ ]
 */
function scaleVector2(r, v) {
    r.r00 = v.x;
    r.r10 = 0.0;
    r.r20 = 0.0;
    r.r01 = 0.0;
    r.r11 = v.y;
    r.r21 = 0.0;
    r.r02 = 0.0;
    r.r21 = 0.0;
    r.r22 = 1.0;
    return r;
}
exports.scaleVector2 = scaleVector2;
/**
 * [ x̂v⃗₀  ŷv⃗₁  ẑv⃗₂ ]
 */
function Scale(v) {
    return {
        r00: v.x, r10: 0.0, r20: 0.0,
        r01: 0.0, r11: v.y, r21: 0.0,
        r02: 0.0, r12: 0.0, r22: v.z
    };
}
exports.Scale = Scale;
/**
 * Mᵣ = [ x̂v⃗₀  ŷv⃗₁  ẑv⃗₂ ]
 */
function scale(r, v) {
    r.r00 = v.x;
    r.r10 = 0.0;
    r.r20 = 0.0;
    r.r01 = 0.0;
    r.r11 = v.y;
    r.r21 = 0.0;
    r.r02 = 0.0;
    r.r12 = 0.0;
    r.r22 = v.z;
    return r;
}
exports.scale = scale;
/**
 * [ x̂  ŷ  ẑ+v⃗ ]
 */
function Translation(v) {
    return {
        r00: 1.0, r10: 0.0, r20: 0.0,
        r01: 0.0, r11: 1.0, r21: 0.0,
        r02: v.x, r12: v.y, r22: 1.0
    };
}
exports.Translation = Translation;
/**
 * Mᵣ = [ x̂  ŷ  ẑ+v⃗ ]
 */
function translation(r, v) {
    r.r00 = 1.0;
    r.r10 = 0.0;
    r.r20 = 0.0;
    r.r01 = 0.0;
    r.r11 = 1.0;
    r.r21 = 0.0;
    r.r02 = v.x;
    r.r12 = v.y;
    r.r22 = 1.0;
    return r;
}
exports.translation = translation;
/**
 * [ x⃗  y⃗  ẑ ]
 */
function ShearVector2(x, y) {
    return {
        r00: x.x, r10: x.y, r20: 0.0,
        r01: y.x, r11: y.y, r21: 0.0,
        r02: 0.0, r12: 0.0, r22: 1.0
    };
}
exports.ShearVector2 = ShearVector2;
/**
 * Mᵣ = [ x⃗  y⃗  ẑ ]
 */
function shearVector2(r, x, y) {
    r.r00 = x.x;
    r.r10 = x.y;
    r.r20 = 0.0;
    r.r01 = y.x;
    r.r11 = y.y;
    r.r21 = 0.0;
    r.r02 = 0.0;
    r.r12 = 0.0;
    r.r22 = 1.0;
    return r;
}
exports.shearVector2 = shearVector2;
/**
 * [ x⃗  y⃗  z⃗ ]
 */
function Shear(x, y, z) {
    return {
        r00: x.x, r10: x.y, r20: x.z,
        r01: y.x, r11: y.y, r21: y.z,
        r02: z.x, r12: z.y, r22: z.z
    };
}
exports.Shear = Shear;
/**
 * Mᵣ = [ x⃗  y⃗  z⃗ ]
 */
function shear(r, x, y, z) {
    r.r00 = x.x;
    r.r10 = x.y;
    r.r20 = x.z;
    r.r01 = y.x;
    r.r11 = y.y;
    r.r21 = y.z;
    r.r02 = z.x;
    r.r12 = z.y;
    r.r22 = z.z;
    return r;
}
exports.shear = shear;
/**
 * [ x⃗  y⃗  ẑ+t⃗ ]
 */
function ShearTranslation(x, y, t) {
    return {
        r00: x.x, r10: x.y, r20: 0.0,
        r01: y.x, r11: y.y, r21: 0.0,
        r02: t.x, r12: t.y, r22: 1.0
    };
}
exports.ShearTranslation = ShearTranslation;
/**
 * Mᵣ = [ x⃗  y⃗  ẑ+t⃗ ]
 */
function shearTranslation(r, x, y, t) {
    r.r00 = x.x;
    r.r10 = x.y;
    r.r20 = 0.0;
    r.r01 = y.x;
    r.r11 = y.y;
    r.r21 = 0.0;
    r.r02 = t.x;
    r.r12 = t.y;
    r.r22 = 1.0;
    return r;
}
exports.shearTranslation = shearTranslation;
/**
 * [ m⁰ m¹ m² ]
 * @deprecated alias of Copy()
 */
exports.ShearMatrix4 = Copy;
/**
 * Mᵣ = [ m⁰ m¹ m² ]
 * @deprecated alias of copy()
 */
exports.shearMatrix4 = copy;
/**
 * A+B
 */
function Add(a, b) {
    return {
        r00: a.r00 + b.r00, r10: a.r10 + b.r10, r20: a.r20 + b.r20,
        r01: a.r01 + b.r01, r11: a.r11 + b.r11, r21: a.r21 + b.r21,
        r02: a.r02 + b.r02, r12: a.r12 + b.r12, r22: a.r22 + b.r22
    };
}
exports.Add = Add;
/**
 * Mᵣ = A+B
 */
function add(r, a, b) {
    r.r00 = a.r00 + b.r00;
    r.r10 = a.r10 + b.r10;
    r.r20 = a.r20 + b.r20;
    r.r01 = a.r01 + b.r01;
    r.r11 = a.r11 + b.r11;
    r.r21 = a.r21 + b.r21;
    r.r02 = a.r02 + b.r02;
    r.r12 = a.r12 + b.r12;
    r.r22 = a.r22 + b.r22;
    return r;
}
exports.add = add;
/**
 * A = A+B
 */
function addAssign(a, b) {
    a.r00 += b.r00;
    a.r10 += b.r10;
    a.r20 += b.r20;
    a.r01 += b.r01;
    a.r11 += b.r11;
    a.r21 += b.r21;
    a.r02 += b.r02;
    a.r12 += b.r12;
    a.r22 += b.r22;
    return a;
}
exports.addAssign = addAssign;
/**
 * A-B
 */
function Subtract(a, b) {
    return {
        r00: a.r00 - b.r00, r10: a.r10 - b.r10, r20: a.r20 - b.r20,
        r01: a.r01 - b.r01, r11: a.r11 - b.r11, r21: a.r21 - b.r21,
        r02: a.r02 - b.r02, r12: a.r12 - b.r12, r22: a.r22 - b.r22
    };
}
exports.Subtract = Subtract;
/**
 * Mᵣ = A-B
 */
function subtract(r, a, b) {
    r.r00 = a.r00 - b.r00;
    r.r10 = a.r10 - b.r10;
    r.r20 = a.r20 - b.r20;
    r.r01 = a.r01 - b.r01;
    r.r11 = a.r11 - b.r11;
    r.r21 = a.r21 - b.r21;
    r.r02 = a.r02 - b.r02;
    r.r12 = a.r12 - b.r12;
    r.r22 = a.r22 - b.r22;
    return r;
}
exports.subtract = subtract;
/**
 * A = A-B
 */
function subtractAssign(a, b) {
    a.r00 -= b.r00;
    a.r10 -= b.r10;
    a.r20 -= b.r20;
    a.r01 -= b.r01;
    a.r11 -= b.r11;
    a.r21 -= b.r21;
    a.r02 -= b.r02;
    a.r12 -= b.r12;
    a.r22 -= b.r22;
    return a;
}
exports.subtractAssign = subtractAssign;
/**
 * M[ x̂v⃗₀  ŷv⃗₁  ẑ ]
 */
function ConcatScaleVector2(m, v) {
    return concatScaleVector2({
        r00: 1.0, r10: 0.0, r20: 0.0,
        r01: 0.0, r11: 1.0, r21: 0.0,
        r02: 0.0, r12: 0.0, r22: 1.0
    }, m, v);
}
exports.ConcatScaleVector2 = ConcatScaleVector2;
/**
 * Mᵣ = M[ x̂v⃗₀  ŷv⃗₁  ẑ ]
 */
function concatScaleVector2(r, m, v) {
    const { x, y } = v;
    r.r00 = m.r00 * x;
    r.r10 = m.r10 * x;
    r.r20 = m.r20 * x;
    r.r01 = m.r01 * y;
    r.r11 = m.r11 * y;
    r.r21 = m.r21 * y;
    r.r02 = m.r02;
    r.r12 = m.r12;
    r.r22 = m.r22;
    return r;
}
exports.concatScaleVector2 = concatScaleVector2;
/**
 * M[ x̂  ŷ  v⃗ ]
 */
function ConcatTranslation(m, v) {
    return concatTranslation({
        r00: 1.0, r10: 0.0, r20: 0.0,
        r01: 0.0, r11: 1.0, r21: 0.0,
        r02: 0.0, r12: 0.0, r22: 1.0
    }, m, v);
}
exports.ConcatTranslation = ConcatTranslation;
/**
 * Mᵣ = M[ x̂  ŷ  v⃗ ]
 */
function concatTranslation(r, m, v) {
    const { r00, r10, r20, r01, r11, r21 } = m;
    const { x, y } = v;
    r.r00 = r00;
    r.r01 = r01;
    r.r02 = r00 * x + r01 * y + m.r02;
    r.r10 = r10;
    r.r11 = r11;
    r.r12 = r10 * x + r11 * y + m.r12;
    r.r20 = r20;
    r.r21 = r21;
    r.r22 = r20 * x + r21 * y + m.r22;
    return r;
}
exports.concatTranslation = concatTranslation;
/**
 * AB₂ₓ₂
 */
function ConcatMatrix2(a, b) {
    return concatMatrix2({
        r00: 1.0, r10: 0.0, r20: 0.0,
        r01: 0.0, r11: 1.0, r21: 0.0,
        r02: 0.0, r12: 0.0, r22: 1.0
    }, a, b);
}
exports.ConcatMatrix2 = ConcatMatrix2;
/**
 * Mᵣ = AB₂ₓ₂
 */
function concatMatrix2(r, a, b) {
    const { r00: a00, r10: a10, r01: a01, r11: a11, r02: a02, r12: a12 } = a;
    const { r00: b00, r10: b10, r01: b01, r11: b11 } = b;
    r.r00 = a00 * b00 + a01 * b10;
    r.r10 = a10 * b00 + a11 * b10;
    r.r20 = 0.0;
    r.r01 = a00 * b01 + a01 * b11;
    r.r11 = a10 * b01 + a11 * b11;
    r.r21 = 0.0;
    r.r02 = a02;
    r.r12 = a12;
    r.r22 = 1.0;
    return r;
}
exports.concatMatrix2 = concatMatrix2;
/**
 * AB₂ₓ₃
 */
function Concat2x3(a, b) {
    return concat2x3({
        r00: 1.0, r10: 0.0, r20: 0.0,
        r01: 0.0, r11: 1.0, r21: 0.0,
        r02: 0.0, r12: 0.0, r22: 1.0
    }, a, b);
}
exports.Concat2x3 = Concat2x3;
/**
 * Mᵣ = AB₂ₓ₃
 */
function concat2x3(r, a, b) {
    const { r00: a00, r10: a10, r01: a01, r11: a11, r02: a02, r12: a12 } = a;
    const { r00: b00, r10: b10, r01: b01, r11: b11, r02: b02, r12: b12 } = b;
    r.r00 = a00 * b00 + a01 * b10;
    r.r10 = a10 * b00 + a11 * b10;
    r.r20 = 0.0;
    r.r01 = a00 * b01 + a01 * b11;
    r.r11 = a10 * b01 + a11 * b11;
    r.r21 = 0.0;
    r.r02 = a00 * b02 + a01 * b12 + a02;
    r.r12 = a10 * b02 + a11 * b12 + a12;
    r.r22 = 1.0;
    return r;
}
exports.concat2x3 = concat2x3;
/**
 * AB
 */
function Concat(a, b) {
    return concat({
        r00: 1.0, r10: 0.0, r20: 0.0,
        r01: 0.0, r11: 1.0, r21: 0.0,
        r02: 0.0, r12: 0.0, r22: 1.0
    }, a, b);
}
exports.Concat = Concat;
/**
 * Mᵣ = AB
 */
function concat(r, a, b) {
    const { r00: a00, r10: a10, r20: a20, r01: a01, r11: a11, r21: a21, r02: a02, r12: a12, r22: a22 } = a;
    const { r00: b00, r10: b10, r20: b20, r01: b01, r11: b11, r21: b21, r02: b02, r12: b12, r22: b22 } = b;
    r.r00 = a00 * b00 + a01 * b10 + a02 * b20;
    r.r10 = a10 * b00 + a11 * b10 + a12 * b20;
    r.r20 = a20 * b00 + a21 * b10 + a22 * b20;
    r.r01 = a00 * b01 + a01 * b11 + a02 * b21;
    r.r11 = a10 * b01 + a11 * b11 + a12 * b21;
    r.r21 = a20 * b01 + a21 * b11 + a22 * b21;
    r.r02 = a00 * b02 + a01 * b12 + a02 * b22;
    r.r12 = a10 * b02 + a11 * b12 + a12 * b22;
    r.r22 = a20 * b02 + a21 * b12 + a22 * b22;
    return r;
}
exports.concat = concat;
/**
 * M⁻¹
 */
function Inverse(m) {
    return inverse({
        r00: 1.0, r10: 0.0, r20: 0.0,
        r01: 0.0, r11: 1.0, r21: 0.0,
        r02: 0.0, r12: 0.0, r22: 1.0
    }, m);
}
exports.Inverse = Inverse;
/**
 * Mᵣ = M⁻¹
 */
function inverse(r, m) {
    let d = determinant(m);
    if (isNanVal(d) || absOf(d) < 1e-10)
        return undefined;
    d = 1.0 / d;
    const { r00, r10, r20, r01, r11, r21, r02, r12, r22 } = m;
    r.r00 = d * (r11 * r22 - r12 * r21);
    r.r10 = -d * (r10 * r22 - r12 * r20);
    r.r20 = d * (r10 * r21 - r11 * r20);
    r.r01 = -d * (r01 * r22 - r02 * r21);
    r.r11 = d * (r00 * r22 - r02 * r20);
    r.r21 = -d * (r00 * r21 - r01 * r20);
    r.r02 = d * (r01 * r12 - r02 * r11);
    r.r12 = -d * (r00 * r12 - r02 * r10);
    r.r22 = d * (r00 * r11 - r01 * r10);
    return r;
}
exports.inverse = inverse;
/**
 * Mᵀ
 */
function Transpose(m) {
    return {
        r00: m.r00, r10: m.r01, r20: m.r02,
        r01: m.r10, r11: m.r11, r21: m.r12,
        r02: m.r20, r12: m.r21, r22: m.r22
    };
}
exports.Transpose = Transpose;
/**
 * Mᵣ = Mᵀ
 */
function transpose(r, m) {
    const { r10, r20, r21 } = m;
    r.r00 = m.r00;
    r.r10 = m.r01;
    r.r20 = m.r02;
    r.r01 = r10;
    r.r11 = m.r11;
    r.r21 = m.r12;
    r.r02 = r20;
    r.r12 = r21;
    r.r22 = m.r22;
    return r;
}
exports.transpose = transpose;
function Copy(m) {
    return {
        r00: m.r00, r10: m.r10, r20: m.r20,
        r01: m.r01, r11: m.r11, r21: m.r21,
        r02: m.r02, r12: m.r12, r22: m.r22
    };
}
exports.Copy = Copy;
function copy(r, m) {
    r.r00 = m.r00;
    r.r10 = m.r10;
    r.r20 = m.r20;
    r.r01 = m.r01;
    r.r11 = m.r11;
    r.r21 = m.r21;
    r.r02 = m.r02;
    r.r12 = m.r12;
    r.r22 = m.r22;
    return r;
}
exports.copy = copy;
